import React from 'react';

import FormGroup from 'reactstrap/lib/FormGroup';
import CustomInput from 'reactstrap/lib/CustomInput';
import InputGroup from 'reactstrap/lib/InputGroup';
import Label from 'reactstrap/lib/Label';

interface OwnProps {
  className?: string;
  disabled?: boolean;
  id: string;
  label: string;
  name: string;
  srOnlyLabel?: boolean;
  value: boolean;
  onChange: (newValue: boolean) => void;
}

type Props = Readonly<OwnProps>;

const FilterCheckBox: React.FC<Props> = ({ className, disabled, id, label, name, srOnlyLabel, value, onChange }) => {
  return (
    <FormGroup tag="fieldset" disabled={disabled} className={className} check inline>
      <div className="filter-soldout-wrapper p-2 rounded-pill">
        {/* <InputGroup> */}
        <CustomInput
          type="switch"
          id={id}
          name={name}
          label={label}
          className="secondary"
          checked={value}
          autocomplete="off"
          onChange={(e) => onChange(e.target.checked)}
        />
        {/* </InputGroup> */}
        {/* <Label for={id} className={(srOnlyLabel ? 'sr-only' : undefined) + '' } inline check>
        {label}
      </Label> */}
      </div>
    </FormGroup>
  );
};

export default React.memo(FilterCheckBox);
